import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import styled from 'styled-components';
export function CircularVolumeIndicator({ volumeControllerRef, }) {
    const [canvas, setCanvas] = useState(null);
    const canvasSizeRef = useRef();
    const setCanvasRef = useCallback((el) => {
        if (el) {
            const { width, height } = el.getBoundingClientRect();
            canvasSizeRef.current = [width, height];
        }
        else {
            canvasSizeRef.current = undefined;
        }
        setCanvas(el);
    }, []);
    useEffect(() => {
        if (!canvas) {
            return;
        }
        function onWindowResize() {
            if (canvas) {
                const { width, height } = canvas.getBoundingClientRect();
                canvasSizeRef.current = [width, height];
            }
        }
        onWindowResize();
        window.addEventListener('resize', onWindowResize);
        return () => {
            window.removeEventListener('resize', onWindowResize);
        };
    }, [canvas]);
    const lastVolumeRef = useRef(0);
    useImperativeHandle(volumeControllerRef, () => ({
        setVolume: (value) => {
            if (!canvas) {
                return;
            }
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                return;
            }
            const { current: canvasSize } = canvasSizeRef;
            if (!canvasSize) {
                return;
            }
            const dpr = window.devicePixelRatio || 1;
            const [width, height] = canvasSize;
            canvas.width = width * dpr;
            canvas.height = height * dpr;
            ctx.scale(dpr, dpr);
            ctx.clearRect(0, 0, width, height);
            const centerX = width / 2;
            const centerY = height / 2;
            const volume = lastVolumeRef.current * 0.8 + value * 0.2;
            lastVolumeRef.current = volume;
            const borderWidth = 10 * volume;
            const radius = Math.min(centerX, centerY) - borderWidth / 2;
            ctx.beginPath();
            ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
            ctx.strokeStyle = 'rgba(255, 255, 255, 0.5)';
            ctx.lineWidth = borderWidth;
            ctx.stroke();
        },
    }), [canvas]);
    return _jsx(CircularVolumeIndicatorRoot, { ref: setCanvasRef });
}
const CircularVolumeIndicatorRoot = styled.canvas `
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`;
